import { api } from "@/services/api";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { PlayerData } from "@/interfaces/liveGamesType";

// Interface estendida para adicionar campos que precisamos
export interface Player extends PlayerData {
  // Campos adicionais que não existem em PlayerData
  teamLogo?: string;
}

// Hook para buscar jogadores por nome
export const useSearchPlayers = (
  searchTerm: string,
  options?: Partial<UseQueryOptions<Player[]>>
) => {
  const response = useQuery({
    queryKey: ["football/getPlayer", searchTerm],
    queryFn: async () => {
      if (!searchTerm) return [];
      
      try {
        const res = await api.get(`/football/getPlayer?playerName=${searchTerm}`);
        return res.data.data || [];
      } catch (error) {
        console.error("Erro ao buscar jogadores:", error);
        return [];
      }
    },
    enabled: !!searchTerm,
    ...options,
  });

  return response;
}; 